import React, { useState, useEffect } from 'react';
import './ResetPasswordForm.css';
import Button from '../Button';
import { useWindowSize } from '../../hooks/useWindowSize';
import { AthenaCore } from 'athena-core';

interface ResetPasswordFormProps {
  email?: string | null;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({ email }) => {
  const windowSize = useWindowSize();

  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [passwordMatches, setPasswordMatches] = useState<boolean>(false);
  const [isStrongPassword, setIsStrongPassword] = useState<boolean>(false);

  useEffect(() => {
    const passwordIsMatching = () => {
      if (password === confirmPassword) {
        return true;
      }

      return false;
    };

    const passwordIsStrong = (): boolean => {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{12,}$/;
      return regex.test(password);
    };

    setPasswordMatches(passwordIsMatching());
    setIsStrongPassword(passwordIsStrong);
  }, [password, confirmPassword]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!passwordMatches) {
      AthenaCore.openModal({
        title: 'Error',
        message: 'passwords do not match.',
        type: 'error',
      });

      return;
    }

    if (!isStrongPassword) {
      AthenaCore.openModal({
        title: 'Error',
        message: 'password is too weak.',
        type: 'error',
      });

      return;
    } else if (passwordMatches && isStrongPassword) {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/api/auth/reset-user-password`,
          {
            method: 'PATCH',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
          }
        );

        if (!response.ok) {
          AthenaCore.throwError({
            status: response.status,
            message: 'Failed to update password.',
          });
        }

        AthenaCore.openModal({
          title: 'Success',
          message: `${response.status}, ${response.statusText}`,
          type: 'success',
        });
      } catch (error) {
        AthenaCore.openModal({
          title: 'Failed to update password, please try again.',
          message:
            error instanceof Error
              ? error.message
              : 'Unknown error sending verification email.',
          type: 'error',
        });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="reset-password-form">
      <label>Password</label>
      <input
        type="password"
        className="input-box"
        name="new-password"
        autoComplete="new-password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
        }}
      ></input>
      <label>Confirm Password</label>
      <input
        type="password"
        name="confirm-password"
        autoComplete="new-password"
        className="input-box"
        value={confirmPassword}
        onChange={(e) => {
          setConfirmPassword(e.target.value);
        }}
      ></input>
      <Button type="submit">Submit</Button>
    </form>
  );
};

export default ResetPasswordForm;
